import React, { useEffect, useState } from "react";
import Modal from "react-awesome-modal";
import { Link } from "react-router-dom";
import useDelete from "../../Hooks/useDelete";
import useUpdate from "../../Hooks/useUpdate";
import useValidateRole from "../../Hooks/useValidateRole";
import Table from "./../../Components/Table";
import Api from "../../Hooks/Api";
import Upload from "../../Hooks/Upload";
import Select from "react-select";
import { Progress } from "reactstrap";
import swal from "sweetalert";
const AddMous = () => {
  const [open, setOpen] = useState(false);
  const [inputs, setInputs] = useState({});
  const [view, setView] = useState(false);
  const [viewMouAreas, setViewMouAreas] = useState(false);
  const [viewMouFocalPoint, setViewMouFocalPoint] = useState(false);
  const [viewMouPartiesInvolved, setViewMouPartiesInvolved] = useState(false);

  const [viewActivities, setViewActivities] = useState(false);
  const [viewDocuments, setViewDocuments] = useState(false);
  const [viewTeam, setViewTeam] = useState(false);
  const [update, setUpdate] = useState(false);
  const [activeTab, setActiveTab] = useState("mou");
  const [PageRole] = useState("Add Mous");
  const [allDocuments, setAllDocuments] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [RowData, setRowData] = useState([]);
  const [allFocalPoints, setAllFocalPoints] = useState([]);
  const [allParties, setAllParties] = useState([]);
  const [allMouAreas, setAllMouAreas] = useState([]);
  const [allTeams, setAllTeams] = useState([]);
  const [mouStatus, setMouStatus] = useState([]);
  const [allActivities, setAllActivities] = useState([]);
  const [documentTypes, setdocumentTypes] = useState([]);
  const [inputsActivities, setInputsActivities] = useState({});
  const [inputsAreas, setInputsAreas] = useState({});
  const [inputsParties, setInputsParties] = useState({});
  const [inputsFocalPoints, setInputsFocalPoints] = useState({});
  const [inputsTeam, setInputsTeam] = useState({});
  const [documents, setDocuments] = useState({});
  const url = "api/mou";

  const [selectedFile, setselectedFile] = useState("");
  const [loaded, setloaded] = useState("");
  const [message, setmessage] = useState("");

  const convertTimestampToDate = (timeStamp) => {
    return new Date(timeStamp).toLocaleDateString("en-US");
  };
  const maxSelectFile = (event) => {
    let files = event.target.files; // create file object
    if (files.length > 1) {
      const msg = "Only One file can be uploaded at a time";
      event.target.value = null;
      setmessage(msg);

      return false;
    }
    return true;
  };
  const onChangeHandler = (event) => {
    //for multiple files
    var files = event.target.files;
    if (maxSelectFile(event)) {
      setselectedFile(files);
      setloaded(0);
    }
  };
  const onClickHandler = (event) => {
    event.preventDefault();
    if (selectedFile) {
      const data = new FormData();
      for (var x = 0; x < selectedFile.length; x++) {
        data.append("file", selectedFile[x]);
      }
      Upload.post("/api/upload/files", data, {
        // receive two parameter endpoint url ,form data
        onUploadProgress: (ProgressEvent) => {
          setloaded((ProgressEvent.loaded / ProgressEvent.total) * 100);
        },
      })
        .then((res) => {
          if (res.status == "200" && res.data.resultCode == "00") {
            setmessage("Uploaded successfully");
            setDocuments((documents) => ({
              ...documents,
              path: res.data.data,
            }));
          } else {
            setmessage("upload fail");
          }
        })
        .catch((err) => {
          setmessage("upload fail");
        });
    } else {
      setmessage("Select a file to upload");
    }
  };
  const handleSelectDocumentsChange = (UserGroup, actionMeta) => {
    setDocuments((documents) => ({
      ...documents,
      [actionMeta.name]: UserGroup.value,
    }));
  };
  const fetchACtivities = async (mouId) => {
    try {
      Api.get("api/activities/findByMouId?mouId=" + mouId)
        .then(function (response) {
          if (response.status === 200) {
            setAllActivities(response.data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };

  const fetchMouAreas = async (mouId) => {
    try {
      Api.get("api/mouAreas/getByMouId?mouId=" + mouId)
        .then(function (response) {
          if (response.status === 200) {
            setAllMouAreas(response.data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {
      console.error("Error fetching incidentTypes:", error);
    }
  };
  const fetchFocalPoints = async (mouId) => {
    try {
      Api.get("api/mouFocalPoints/getByMouId?mouId=" + mouId)
        .then(function (response) {
          if (response.status === 200) {
            setAllFocalPoints(response.data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {
      console.error("Error fetching incidentTypes:", error);
    }
  };
  const fetchParties = async (mouId) => {
    try {
      Api.get("api/mouParties/getByMouId?mouId=" + mouId)
        .then(function (response) {
          if (response.status === 200) {
            setAllParties(response.data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };

  const fetchDocuments = async (mouId) => {
    try {
      Api.get("api/documents/getByMouId?mouId=" + mouId)
        .then(function (response) {
          if (response.status === 200) {
            setAllDocuments(response.data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };
  const fetchteam = async (mouId) => {
    try {
      Api.get("api/teams/findByMouId?mouId=" + mouId)
        .then(function (response) {
          if (response.status === 200) {
            setAllTeams(response.data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {
      console.error("Error fetching incidentTypes:", error);
    }
  };

  const fetchMouStatus = async () => {
    try {
      Api.get("api/mouStatus/getAll?page=0&size=100")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setMouStatus(data.mouStatus);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };

  const fetchCountries = async () => {
    try {
      Api.get("api/countries/getAll")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setCountryOptions(data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {
      console.error("Error fetching incidentTypes:", error);
    }
  };
  const fetchDocumentTypes = async () => {
    try {
      Api.get("api/docType/getAll?page=0&size=100")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            data.docType.forEach((k) => {
              let col = {
                value: k.id,
                label: k.name,
              };
              setdocumentTypes((documentTypes) => [...documentTypes, col]);
            });
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {
      console.error("Error fetching incidentTypes:", error);
    }
  };
  const MoreActions = (props) => {
    return (
      <span>
        <a
          class="btn btn-secondary btn-sm dropdown-toggle"
          href="#"
          role="button"
          id="dropdownMenuLink"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          More Actions&nbsp;&nbsp;
          <i class="fa fa-caret-down" aria-hidden="true"></i>
        </a>

        <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
          <a
            style={{ cursor: "pointer" }}
            class="dropdown-item "
            onClick={(e) => handleView(props.selecteditem, e)}
          >
            View
          </a>

          <a
            style={{ cursor: "pointer" }}
            class="dropdown-item "
            onClick={(e) => handleEdit(props.selecteditem, e)}
          >
            Edit
          </a>

          <a
            style={{ cursor: "pointer" }}
            class="dropdown-item "
            onClick={(e) => HandleDelete(props.selecteditem, e)}
          >
            Delete
          </a>
        </div>
      </span>
    );
  };
  const setMoudata = async (data) => {
    const rows = data?.mou || [];

    rows.forEach((k) => {
      const Rowdata = {
        id: k.id,
        name: k.name,
        category: k.category,
        description: k.description,
        status: k.status,
        Actions: <MoreActions selecteditem={k} />,
      };
      setRowData((inputs) => [...inputs, Rowdata]);
    });
  };
  const FetchAll = async () => {
    setRowData([]);
    try {
      Api.get(url + "/getAll?page=0&size=10")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setMoudata(data);
            const totalPages = data.totalPages;
            for (let i = 0; i < totalPages; i++) {
              let nextPage = parseFloat(i) + parseFloat(1);
              Api.get(url + "/getAll?page=" + nextPage + "&size=10")
                .then(function (response) {
                  if (response.status === 200) {
                    const data = response.data;
                    setMoudata(data);
                  }
                })
                .catch(function (error) {})
                .then(function () {
                  // always executed
                });
            }
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };
  useEffect(() => {
    FetchAll();
    fetchCountries();
    fetchMouStatus();
    fetchDocumentTypes();
  }, []);

  const handleOpenModal = () => {
    const currentUserName = window.sessionStorage.getItem("UserName");
    setInputs({ createdBy: currentUserName });
    setOpen(true);
  };

  const handleInputChange = (event) => {
    event.persist();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setInputs((inputs) => ({ ...inputs, [name]: value }));
  };
  const handlePartyInputChange = (event) => {
    event.persist();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setInputsParties((inputs) => ({ ...inputs, [name]: value }));
  };
  const handleFocalPointsInputChange = (event) => {
    event.persist();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setInputsFocalPoints((inputs) => ({ ...inputs, [name]: value }));
  };
  const handleAreaInputChange = (event) => {
    event.persist();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setInputsAreas((inputs) => ({ ...inputs, [name]: value }));
  };
  const handleEdit = (k) => {
    setInputs(k);
    setInputsActivities((inputsActivities) => ({
      ...inputsActivities,
      ["mouId"]: k.id,
    }));
    setInputsTeam((inputsTeam) => ({ ...inputsTeam, ["mouId"]: k.id }));
    setDocuments((documents) => ({ ...documents, ["mouId"]: k.id }));
    setInputsAreas((inputsAreas) => ({ ...inputsAreas, ["mouId"]: k.id }));
    setInputsParties((inputsParties) => ({
      ...inputsParties,
      ["mouId"]: k.id,
    }));
    setInputsFocalPoints((inputsFocalPoints) => ({
      ...inputsFocalPoints,
      ["mouId"]: k.id,
    }));
    if (k.id) {
      fetchACtivities(k.id);
      fetchDocuments(k.id);
      fetchteam(k.id);
      fetchMouAreas(k.id);
      fetchFocalPoints(k.id);
      fetchParties(k.id);
      setOpen(true);
      setUpdate(true);
      setView(false);
    } else {
      alert("Select a record to edit");
    }
  };

  const handleView = (k) => {
    setInputs(k);
    setInputsActivities((inputsActivities) => ({
      ...inputsActivities,
      ["mouId"]: k.id,
    }));
    setInputsTeam((inputsTeam) => ({ ...inputsTeam, ["mouId"]: k.id }));
    setDocuments((documents) => ({ ...documents, ["mouId"]: k.id }));
    setInputsAreas((inputsAreas) => ({ ...inputsAreas, ["mouId"]: k.id }));
    setInputsParties((inputsParties) => ({
      ...inputsParties,
      ["mouId"]: k.id,
    }));
    setInputsFocalPoints((inputsFocalPoints) => ({
      ...inputsFocalPoints,
      ["mouId"]: k.id,
    }));
    if (k.id) {
      fetchACtivities(k.id);
      fetchDocuments(k.id);
      fetchteam(k.id);
      fetchMouAreas(k.id);
      fetchFocalPoints(k.id);
      fetchParties(k.id);

      setViewTeam(true);
      setViewActivities(true);
      setViewDocuments(true);
      setViewMouAreas(true);
      setViewMouFocalPoint(true);
      setViewMouPartiesInvolved(true);
      setView(true);
      setUpdate(false);
      setOpen(true);
    } else {
      alert("Select a record to view");
    }
  };

  const handleCloseModal = () => {
    setInputs({});
    setOpen(false);
    setView(false);
    setUpdate(false);
  };

  const HandleUpdate = (inputs, url) => {
    useUpdate(url + "/update", inputs);
    setTimeout(function () {
      FetchAll();
    }, 4000);
  };
  const HandleSubmitDocuments = (event) => {
    event.preventDefault();
    if (!documents.mouId || documents.mouId == "undefined") {
      alert("Add or select campaign first");
      return;
    }
    if (update) {
      HandleUpdate(documents, "api/documents");
    } else {
      HandleSave(documents, "api/documents", "Documents");
    }
    setTimeout(function () {
      fetchDocuments(inputs.id);
    }, 4000);
  };
  const handleSubmitFocalPoint = (event) => {
    event.preventDefault();
    if (!inputsFocalPoints.mouId || inputsFocalPoints.mouId == "undefined") {
      alert("Add or select mou first");
      return;
    }
    if (update) {
      HandleUpdate(inputsFocalPoints, "api/mouFocalPoints");
    } else {
      HandleSave(inputsFocalPoints, "api/mouFocalPoints", "mouFocalPoints");
    }
    setTimeout(function () {
      fetchFocalPoints(inputs.id);
    }, 4000);
  };
  const handleSubmitMouAreas = (event) => {
    event.preventDefault();
    if (!inputsAreas.mouId || inputsAreas.mouId == "undefined") {
      alert("Add or select mou first");
      return;
    }
    if (update) {
      HandleUpdate(inputsAreas, "api/mouAreas");
    } else {
      HandleSave(inputsAreas, "api/mouAreas", "mouAreas");
    }
    setTimeout(function () {
      fetchMouAreas(inputs.id);
    }, 4000);
  };
  const handleSubmitParties = (event) => {
    event.preventDefault();
    if (!inputsParties.mouId || inputsParties.mouId == "undefined") {
      alert("Add or select mou first");
      return;
    }
    if (update) {
      HandleUpdate(inputsParties, "api/mou");
    } else {
      HandleSave(inputsParties, "api/mou", "Team");
    }
    setTimeout(function () {
      fetchParties(inputs.id);
    }, 4000);
  };
  const handleSubmitTeam = (event) => {
    event.preventDefault();
    if (!inputsTeam.mouId || inputsTeam.mouId == "undefined") {
      alert("Add or select campaign first");
      return;
    }
    if (update) {
      HandleUpdate(inputsTeam, "api/teams");
    } else {
      HandleSave(inputsTeam, "api/teams", "Team");
    }
    setTimeout(function () {
      fetchteam(inputs.id);
    }, 4000);
  };
  const handleActivitiesInputChange = (event) => {
    event.persist();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setInputsActivities((inputsActivities) => ({
      ...inputsActivities,
      [name]: value,
    }));
  };
  const handleTeamInputChange = (event) => {
    event.persist();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setInputsTeam((inputsTeam) => ({ ...inputsTeam, [name]: value }));
  };
  const handleDocumentsInputChange = (event) => {
    event.persist();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setDocuments((documents) => ({ ...documents, [name]: value }));
  };
  const HandleSubmitActivities = (event) => {
    event.preventDefault();
    if (!inputsActivities.mouId || inputsActivities.mouId == "undefined") {
      alert("Add or select marketing first");
      return;
    }
    if (update) {
      HandleUpdate(inputsActivities, "api/activities");
    } else {
      HandleSave(inputsActivities, "api/activities", "Activities");
    }
    setTimeout(function () {
      fetchACtivities(inputs.id);
    }, 4000);
  };
  const useSave = (url = ``, inputs = {}, menu = ``, config = {}) => {
    let data;
    let headers;

    if (inputs instanceof FormData) {
      data = inputs;
      headers = { ...config.headers }; // Don't set Content-Type header, let the browser set it
    } else {
      data = JSON.stringify(inputs);
      headers = { "Content-Type": "application/json", ...config.headers };
    }
    Api.post(url, data, { headers })
      .then((response) => {
        if (response.data.resultCode === "00") {
          if (menu === "Mou") {
            var result = JSON.parse(response.data.data);
            setInputsActivities((inputsActivities) => ({
              ...inputsActivities,
              ["mouId"]: result.id,
            }));
            setInputsTeam((inputsTeam) => ({
              ...inputsTeam,
              ["mouId"]: result.id,
            }));
            setDocuments((documents) => ({
              ...documents,
              ["mouId"]: result.id,
            }));
            setInputsAreas((inputsAreas) => ({
              ...inputsAreas,
              ["mouId"]: result.id,
            }));
            setInputsParties((inputsParties) => ({
              ...inputsParties,
              ["mouId"]: result.id,
            }));
            setInputsFocalPoints((inputsFocalPoints) => ({
              ...inputsFocalPoints,
              ["mouId"]: result.id,
            }));
          }

          swal("", "saved", "success");
        } else {
          swal("", response.data.description, "error");
        }
      })
      .catch((error) => {
        swal("", "Failed", "error");
      });
  };
  const HandleSave = (inputs, url, menu) => {
    useSave(url + "/create", inputs, menu);
    setTimeout(function () {
      FetchAll();
    }, 4000);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (update) {
      HandleUpdate(inputs, url);
    } else {
      HandleSave(inputs, url, "Mou");
    }
  };

  const CallDeleteHook = (id) => {
    useDelete(url + "/delete?id=" + id);
    FetchAll();
  };

  const HandleDelete = (k) => {
    if (k.id) {
      CallDeleteHook(k.id);
    } else {
      alert("Select a record to delete");
    }
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(timestamp);
    return date.toISOString().slice(0, 16);
  };

  const columns = [
    { label: "Name", field: "name", sort: "asc" },

    { label: "Description", field: "description", sort: "asc" },
    { label: "Status", field: "status", sort: "asc" },
    { label: "Actions", field: "Actions", sort: "asc" },
  ];

  const ActionsBtn = () => (
    <div>
      {useValidateRole(PageRole, "Edit") && (
        <button
          className="btn btn-primary p-2"
          type="button"
          onClick={handleEdit}
        >
          Update
        </button>
      )}
      &nbsp; &nbsp;
      {useValidateRole(PageRole, "Remove") && (
        <button onClick={HandleDelete} className="btn btn-danger p-2">
          Delete
        </button>
      )}
      &nbsp;
      <button
        className="btn btn-warning p-2"
        type="button"
        onClick={handleCloseModal}
      >
        Close
      </button>
    </div>
  );

  const handleNext = () => {
    const tabs = ["mou", "areas", "focalpoints", "parties", "documents"];
    const currentIndex = tabs.indexOf(activeTab);
    if (currentIndex < tabs.length - 1) {
      setActiveTab(tabs[currentIndex + 1]);
    }
  };

  const handlePrev = () => {
    const tabs = ["mou", "areas", "focalpoints", "parties", "documents"];
    const currentIndex = tabs.indexOf(activeTab);
    if (currentIndex > 0) {
      setActiveTab(tabs[currentIndex - 1]);
    }
  };

  return (
    <div id="content" className="content">
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item">
          <Link to="/">Home</Link>
        </li>
        <li className="breadcrumb-item active">MOUs</li>
      </ol>
      <h1 className="page-header mb-3">MOUs</h1>
      <div style={{ backgroundColor: "white" }}>
        <div className="row">
          <div className="col-sm-12 d-flex flex-row float-right">
            &nbsp; &nbsp; &nbsp;
            {useValidateRole(PageRole, "AddNew") && (
              <button
                onClick={handleOpenModal}
                className="btn btn-primary p-2"
                style={{ marginRight: 5, marginTop: 5 }}
              >
                &nbsp; New mou&nbsp;
              </button>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <Table Rows={RowData} columns={columns} />
          </div>
        </div>
      </div>

      <Modal visible={open} width="80%" height="80%" effect="fadeInUp">
        <div style={{ overflowY: "auto", height: "100%" }}>
          <a className="close" onClick={handleCloseModal}>
            &times;
          </a>
          <div className="container-fluid">
            <div className="col-sm-12">
              <div className="ibox-content">
                <br />

                <div>
                  <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item" style={{ cursor: "pointer" }}>
                      <a
                        className={`nav-link ${
                          activeTab === "mou" ? "active" : ""
                        }`}
                        id="mou-tab"
                        onClick={() => setActiveTab("mou")}
                        role="tab"
                        aria-selected={activeTab === "mou"}
                      >
                        MOU
                      </a>
                    </li>
                    <li className="nav-item" style={{ cursor: "pointer" }}>
                      <a
                        className={`nav-link ${
                          activeTab === "areas" ? "active" : ""
                        }`}
                        id="area-tab"
                        onClick={() => setActiveTab("areas")}
                        role="tab"
                        aria-selected={activeTab === "areas"}
                      >
                        Area of Cooperation
                      </a>
                    </li>
                    <li className="nav-item" style={{ cursor: "pointer" }}>
                      <a
                        className={`nav-link ${
                          activeTab === "focalpoints" ? "active" : ""
                        }`}
                        id="focalpoints-tab"
                        onClick={() => setActiveTab("focalpoints")}
                        role="tab"
                        aria-selected={activeTab === "focalpoints"}
                      >
                        Focal Points
                      </a>
                    </li>
                    <li className="nav-item" style={{ cursor: "pointer" }}>
                      <a
                        className={`nav-link ${
                          activeTab === "parties" ? "active" : ""
                        }`}
                        id="parties-tab"
                        onClick={() => setActiveTab("parties")}
                        role="tab"
                        aria-selected={activeTab === "parties"}
                      >
                        Parties
                      </a>
                    </li>
                    <li className="nav-item" style={{ cursor: "pointer" }}>
                      <a
                        className={`nav-link ${
                          activeTab === "activities" ? "active" : ""
                        }`}
                        id="activities-tab"
                        onClick={() => setActiveTab("activities")}
                        role="tab"
                        aria-selected={activeTab === "activities"}
                      >
                        Activity(s)
                      </a>
                    </li>
                    <li className="nav-item" style={{ cursor: "pointer" }}>
                      <a
                        className={`nav-link ${
                          activeTab === "Team" ? "active" : ""
                        }`}
                        id="Team-tab"
                        onClick={() => setActiveTab("Team")}
                        role="tab"
                        aria-selected={activeTab === "Team"}
                      >
                        Responsibilty
                      </a>
                    </li>
                    <li className="nav-item" style={{ cursor: "pointer" }}>
                      <a
                        className={`nav-link ${
                          activeTab === "documents" ? "active" : ""
                        }`}
                        id="documents-tab"
                        onClick={() => setActiveTab("documents")}
                        role="tab"
                        aria-selected={activeTab === "documents"}
                      >
                        Documents
                      </a>
                    </li>
                  </ul>
                  <div className="tab-content" id="myTabContent">
                    <div
                      className={`tab-pane fade ${
                        activeTab === "mou" ? "show active" : ""
                      }`}
                      id="mou-tab-pane"
                      role="tabpanel"
                      aria-labelledby="mou-tab"
                    >
                      {view ? (
                        <div>
                          <h3>MOUs</h3>
                          <table className="table table-sm">
                            <tbody>
                              <tr>
                                <td className="font-weight-bold">Name:</td>
                                <td>{inputs.name}</td>
                              </tr>
                              <tr>
                                <td className="font-weight-bold">
                                  Description:
                                </td>
                                <td>{inputs.description}</td>
                              </tr>
                              <tr>
                                <td className="font-weight-bold">Status:</td>
                                <td>{inputs.status}</td>
                              </tr>
                            </tbody>
                          </table>
                          <br />
                          <div
                            style={{
                              display: "flex",
                              "justify-content": "flex-end",
                            }}
                          >
                            <ActionsBtn />
                          </div>
                        </div>
                      ) : (
                        <form
                          className="form-horizontal"
                          onSubmit={handleSubmit}
                        >
                          <div className="tab-content" id="myTabContent">
                            <div
                              className={`tab-pane fade ${
                                activeTab === "mou" ? "show active" : ""
                              }`}
                              id="mou-tab-pane"
                              role="tabpanel"
                              aria-labelledby="mou-tab"
                            >
                              <h3>MOUs</h3>
                              <form
                                className="form-horizontal"
                                onSubmit={handleSubmit}
                              >
                                <div className="row">
                                  <div className="col-sm">
                                    <div className="form-group">
                                      <label
                                        htmlFor="name"
                                        className="font-weight-bold"
                                      >
                                        Name
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="name"
                                        required
                                        value={inputs.name || ""}
                                        onChange={(e) => handleInputChange(e)}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-sm">
                                    <div className="form-group">
                                      <label
                                        htmlFor="description"
                                        className="font-weight-bold"
                                      >
                                        Description
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="description"
                                        required
                                        value={inputs.description || ""}
                                        onChange={(e) => handleInputChange(e)}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-sm">
                                    <div className="form-group">
                                      <label
                                        htmlFor="signedDate"
                                        className="font-weight-bold"
                                      >
                                        Signed Date
                                      </label>
                                      <input
                                        type="datetime-local"
                                        className="form-control"
                                        name="signedDate"
                                        required
                                        value={inputs.signedDate || ""}
                                        onChange={(e) => handleInputChange(e)}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-sm">
                                    <div className="form-group">
                                      <label
                                        htmlFor="status"
                                        className="font-weight-bold"
                                      >
                                        Select Status:
                                      </label>
                                      <select
                                        className="form-control"
                                        name="status"
                                        required
                                        value={inputs.status || ""}
                                        onChange={handleInputChange}
                                      >
                                        <option value="">Select Status</option>
                                        {mouStatus &&
                                          mouStatus.map((category) => (
                                            <option
                                              key={category.id}
                                              value={category.name}
                                            >
                                              {category.name}
                                            </option>
                                          ))}
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-sm">
                                    <div className="form-group">
                                      <label
                                        htmlFor="plannedStartDate"
                                        className="font-weight-bold"
                                      >
                                        Start Date
                                      </label>
                                      <input
                                        type="datetime-local"
                                        className="form-control"
                                        name="plannedStartDate"
                                        required
                                        value={inputs.plannedStartDate || ""}
                                        onChange={(e) => handleInputChange(e)}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-sm">
                                    <div className="form-group">
                                      <label
                                        htmlFor="plannedEndDate"
                                        className="font-weight-bold"
                                      >
                                        End Date
                                      </label>
                                      <input
                                        type="datetime-local"
                                        className="form-control"
                                        name="plannedEndDate"
                                        required
                                        value={inputs.plannedEndDate || ""}
                                        onChange={(e) => handleInputChange(e)}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-sm">
                                    <div className="form-group">
                                      <label
                                        htmlFor="actualStartDate"
                                        className="font-weight-bold"
                                      >
                                        Actual Start Date
                                      </label>
                                      <input
                                        type="datetime-local"
                                        className="form-control"
                                        name="actualStartDate"
                                        required
                                        value={inputs.actualStartDate || ""}
                                        onChange={(e) => handleInputChange(e)}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-sm">
                                    <div className="form-group">
                                      <label
                                        htmlFor="actualEndDate"
                                        className="font-weight-bold"
                                      >
                                        Actual End Date
                                      </label>
                                      <input
                                        type="datetime-local"
                                        className="form-control"
                                        name="actualEndDate"
                                        required
                                        value={inputs.actualEndDate || ""}
                                        onChange={(e) => handleInputChange(e)}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <div className="d-flex flex-row">
                              {update ? (
                                <button
                                  className="btn btn-primary p-2"
                                  type="submit"
                                >
                                  Update
                                </button>
                              ) : (
                                <button
                                  className="btn btn-primary p-2"
                                  type="submit"
                                >
                                  Submit
                                </button>
                              )}
                              &nbsp;
                              <button
                                className="btn btn-warning p-2"
                                type="button"
                                onClick={handleCloseModal}
                              >
                                Close
                              </button>
                            </div>
                            <br />
                          </div>
                          {/* <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
                                                        <button type="button" className="btn btn-secondary" onClick={handlePrev}>Previous</button>
                                                        {activeTab === 'documents' ? (
                                                            <button type="submit" className="btn btn-primary">Submit</button>
                                                        ) : (
                                                            <button type="button" className="btn btn-primary" onClick={handleNext}>Next</button>
                                                        )}
                                                    </div> */}
                        </form>
                      )}
                    </div>
                    <div
                      className={`tab-pane fade ${
                        activeTab === "areas" ? "show active" : ""
                      }`}
                      id="areas-tab-pane"
                      role="tabpanel"
                      aria-labelledby="area-tab"
                    >
                      {viewMouAreas ? (
                        <div>
                          <button
                            className="btn-primary"
                            onClick={() => {
                              setViewMouAreas(false);
                            }}
                          >
                            Add MOU Area
                          </button>
                          <table className="table table-sm">
                            <thead>
                              <tr>
                                <th>Name</th>
                                <th>Description</th>
                              </tr>
                            </thead>
                            <tbody>
                              {allMouAreas.map((area) => (
                                <tr key={area.id}>
                                  <td>{area.name}</td>
                                  <td>{area.description}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <form
                          className="form-horizontal"
                          onSubmit={handleSubmitMouAreas}
                        >
                          <button
                            className="btn-warning"
                            onClick={() => {
                              setViewMouAreas(true);
                            }}
                          >
                            Back
                          </button>
                          <div className="row">
                            <div className="col-sm">
                              <div className="form-group">
                                <label
                                  htmlFor="areaName"
                                  className="font-weight-bold"
                                >
                                  Area of Cooperation
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="name"
                                  required
                                  value={inputsAreas.name || ""}
                                  onChange={(e) => handleAreaInputChange(e)}
                                />
                              </div>
                            </div>
                            <div className="col-sm">
                              <div className="form-group">
                                <label
                                  htmlFor="areaDescription"
                                  className="font-weight-bold"
                                >
                                  Area Description
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="description"
                                  required
                                  value={inputsAreas.description || ""}
                                  onChange={(e) => handleAreaInputChange(e)}
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <div className="d-flex flex-row">
                              {update ? (
                                <button
                                  className="btn btn-primary p-2"
                                  type="submit"
                                >
                                  Update
                                </button>
                              ) : (
                                <button
                                  className="btn btn-primary p-2"
                                  type="submit"
                                >
                                  Submit
                                </button>
                              )}
                              &nbsp;
                              <button
                                className="btn btn-warning p-2"
                                type="button"
                                onClick={handleCloseModal}
                              >
                                Close
                              </button>
                            </div>
                            <br />
                          </div>
                        </form>
                      )}
                    </div>

                    <div
                      className={`tab-pane fade ${
                        activeTab === "focalpoints" ? "show active" : ""
                      }`}
                      id="focalpoints-tab-pane"
                      role="tabpanel"
                      aria-labelledby="focalpoints-tab"
                    >
                      {viewMouFocalPoint ? (
                        <div>
                          <button
                            className="btn-primary"
                            onClick={() => {
                              setViewMouFocalPoint(false);
                            }}
                          >
                            Add MOU focal point
                          </button>
                          <table className="table table-sm">
                            <thead>
                              <tr>
                                <th>Name</th>
                                <th>Description</th>
                              </tr>
                            </thead>
                            <tbody>
                              {allFocalPoints.map((points) => (
                                <tr key={points.id}>
                                  <td>{points.name}</td>
                                  <td>{points.description}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <form
                          className="form-horizontal"
                          onSubmit={handleSubmitFocalPoint}
                        >
                          <button
                            className="btn-warning"
                            onClick={() => {
                              setViewMouFocalPoint(true);
                            }}
                          >
                            Back
                          </button>
                          <div className="row">
                            <div className="col-sm">
                              <div className="form-group">
                                <label
                                  htmlFor="focalPointName"
                                  className="font-weight-bold"
                                >
                                  Focal Point Name
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="name"
                                  required
                                  value={inputsFocalPoints.name || ""}
                                  onChange={(e) =>
                                    handleFocalPointsInputChange(e)
                                  }
                                />
                              </div>
                              <div className="form-group">
                                <label
                                  htmlFor="countryId"
                                  className="font-weight-bold"
                                >
                                  Country
                                </label>
                                <select
                                  className="form-control"
                                  name="countryId"
                                  required
                                  value={inputsFocalPoints.countryId || ""}
                                  onChange={(e) =>
                                    handleFocalPointsInputChange(e)
                                  }
                                >
                                  <option value="">Select Country</option>
                                  {countryOptions &&
                                    countryOptions.map((country) => (
                                      <option
                                        key={country.countryId}
                                        value={country.countryId}
                                      >
                                        {country.name}
                                      </option>
                                    ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-sm">
                              <div className="form-group">
                                <label
                                  htmlFor="focalPointDescription"
                                  className="font-weight-bold"
                                >
                                  Focal Point Description
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="description"
                                  required
                                  value={inputsFocalPoints.description || ""}
                                  onChange={(e) =>
                                    handleFocalPointsInputChange(e)
                                  }
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <div className="d-flex flex-row">
                              {update ? (
                                <button
                                  className="btn btn-primary p-2"
                                  type="submit"
                                >
                                  Update
                                </button>
                              ) : (
                                <button
                                  className="btn btn-primary p-2"
                                  type="submit"
                                >
                                  Submit
                                </button>
                              )}
                              &nbsp;
                              <button
                                className="btn btn-warning p-2"
                                type="button"
                                onClick={handleCloseModal}
                              >
                                Close
                              </button>
                            </div>
                            <br />
                          </div>
                        </form>
                      )}
                    </div>
                    <div
                      className={`tab-pane fade ${
                        activeTab === "parties" ? "show active" : ""
                      }`}
                      id="parties-tab-pane"
                      role="tabpanel"
                      aria-labelledby="parties-tab"
                    >
                      {viewMouPartiesInvolved ? (
                        <div>
                          <button
                            className="btn-primary"
                            onClick={() => {
                              setViewMouPartiesInvolved(false);
                            }}
                          >
                            Add Party Involved
                          </button>
                          <table className="table table-sm">
                            <thead>
                              <tr>
                                <th>Parties</th>
                                <th>Description</th>
                              </tr>
                            </thead>
                            <tbody>
                              {allParties.map((parties) => (
                                <tr key={parties.id}>
                                  <td>{parties.name}</td>
                                  <td>{parties.description}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <form
                          className="form-horizontal"
                          onSubmit={handleSubmitParties}
                        >
                          <button
                            className="btn-warning"
                            onClick={() => {
                              setViewMouPartiesInvolved(true);
                            }}
                          >
                            Back
                          </button>
                          <div className="row">
                            <div className="col-sm">
                              <div className="form-group">
                                <label
                                  htmlFor="partyName"
                                  className="font-weight-bold"
                                >
                                  Party Name
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="name"
                                  required
                                  value={inputsParties.name || ""}
                                  onChange={(e) => handlePartyInputChange(e)}
                                />
                              </div>
                              <div className="form-group">
                                <label
                                  htmlFor="partyDescription"
                                  className="font-weight-bold"
                                >
                                  Party Description
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="description"
                                  required
                                  value={inputsParties.description || ""}
                                  onChange={(e) => handlePartyInputChange(e)}
                                />
                              </div>
                            </div>
                            <div className="col-sm">
                              <div className="form-group">
                                <label
                                  htmlFor="countryId"
                                  className="font-weight-bold"
                                >
                                  Country
                                </label>
                                <select
                                  className="form-control"
                                  name="countryId"
                                  required
                                  value={inputsParties.countryId || ""}
                                  onChange={(e) => handlePartyInputChange(e)}
                                >
                                  <option value="">Select Country</option>
                                  {countryOptions &&
                                    countryOptions.map((country) => (
                                      <option
                                        key={country.countryId}
                                        value={country.countryId}
                                      >
                                        {country.name}
                                      </option>
                                    ))}
                                </select>
                              </div>
                            </div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <div className="d-flex flex-row">
                              {update ? (
                                <button
                                  className="btn btn-primary p-2"
                                  type="submit"
                                >
                                  Update
                                </button>
                              ) : (
                                <button
                                  className="btn btn-primary p-2"
                                  type="submit"
                                >
                                  Submit
                                </button>
                              )}
                              &nbsp;
                              <button
                                className="btn btn-warning p-2"
                                type="button"
                                onClick={handleCloseModal}
                              >
                                Close
                              </button>
                            </div>
                            <br />
                          </div>
                        </form>
                      )}
                    </div>
                    <div
                      className={`tab-pane fade ${
                        activeTab === "Team" ? "show active" : ""
                      }`}
                      id="Team-tab-pane"
                      role="tabpanel"
                      aria-labelledby="Team-tab"
                    >
                      {viewTeam ? (
                        <div>
                          <button
                            className="btn-primary"
                            onClick={() => {
                              setViewTeam(false);
                            }}
                          >
                            Add Responsibilty
                          </button>
                          <br />
                          <table className="table table-sm">
                            <tr>
                              <th>id</th>
                              <th>Name </th>
                            </tr>
                            <tbody>
                              {allTeams.map((d) => (
                                <tr key={d.id}>
                                  <td>{d.id}</td>
                                  <td>{d.name}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          <br />
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <ActionsBtn />
                          </div>
                          <br />
                        </div>
                      ) : (
                        <form
                          className="form-horizontal"
                          onSubmit={handleSubmitTeam}
                        >
                          <button
                            className="btn-warning"
                            onClick={() => {
                              setViewTeam(true);
                            }}
                          >
                            Back
                          </button>
                          <div className="row">
                            <div className="col-sm-6">
                              <div className="form-group">
                                <label
                                  htmlFor="name"
                                  className="font-weight-bold"
                                >
                                  Name
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="name"
                                  required
                                  value={inputsTeam.name || ""}
                                  onChange={handleTeamInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <div className="d-flex flex-row">
                              {update ? (
                                <button
                                  className="btn btn-primary p-2"
                                  type="submit"
                                >
                                  Update
                                </button>
                              ) : (
                                <button
                                  className="btn btn-primary p-2"
                                  type="submit"
                                >
                                  Submit
                                </button>
                              )}
                              &nbsp;
                              <button
                                className="btn btn-warning p-2"
                                type="button"
                                onClick={handleCloseModal}
                              >
                                Close
                              </button>
                            </div>
                            <br />
                          </div>
                        </form>
                      )}
                    </div>
                    <div
                      className={`tab-pane fade ${
                        activeTab === "activities" ? "show active" : ""
                      }`}
                      id="activities-tab-pane"
                      role="tabpanel"
                      aria-labelledby="activities-tab"
                    >
                      {viewActivities ? (
                        <div>
                          <button
                            className="btn-primary"
                            onClick={() => {
                              setViewActivities(false);
                            }}
                          >
                            Add Activity
                          </button>
                          <br />
                          <table className="table table-sm">
                            <tr>
                              <th>id</th>
                              <th>Name</th>
                              <th>Description</th>
                              <th>Planned StartDate</th>
                              <th>Timeline</th>
                              <th>Actual StartDate</th>
                              <th>Actual EndDate</th>
                              <th>Planned Budget</th>
                              <th>Actual Budget</th>
                              <th>Status</th>
                            </tr>
                            <tbody>
                              {allActivities.map((d) => (
                                <tr key={d.id}>
                                  <td>{d.id}</td>
                                  <td>{d.name}</td>
                                  <td>{d.description}</td>
                                  <td>
                                    {d.plannedStartDate
                                      ? convertTimestampToDate(
                                          d.plannedStartDate,
                                        )
                                      : "N/A"}
                                  </td>
                                  <td>
                                    {d.plannedEndDate
                                      ? convertTimestampToDate(d.plannedEndDate)
                                      : "N/A"}
                                  </td>
                                  <td>
                                    {d.actualStartDate
                                      ? convertTimestampToDate(
                                          d.actualStartDate,
                                        )
                                      : "N/A"}
                                  </td>
                                  <td>
                                    {d.actualEndDate
                                      ? convertTimestampToDate(d.actualEndDate)
                                      : "N/A"}
                                  </td>
                                  <td>{d.plannedBudget}</td>
                                  <td>{d.actualBudget}</td>
                                  <td>{d.status}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          <br />
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <ActionsBtn />
                          </div>
                          <br />
                        </div>
                      ) : (
                        <form
                          className="form-horizontal"
                          onSubmit={HandleSubmitActivities}
                        >
                          <button
                            className="btn-warning"
                            onClick={() => {
                              setViewActivities(true);
                            }}
                          >
                            Back
                          </button>
                          <div className="row">
                            <div className="col-sm">
                              <div className="form-group">
                                <label
                                  htmlFor="code"
                                  className="font-weight-bold"
                                >
                                  Name
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="name"
                                  required
                                  value={inputsActivities.name || ""}
                                  onChange={handleActivitiesInputChange}
                                />
                              </div>
                            </div>
                            <div className="col-sm">
                              <div className="form-group">
                                <label
                                  htmlFor="code"
                                  className="font-weight-bold"
                                >
                                  Status
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="status"
                                  required
                                  value={inputsActivities.status || ""}
                                  onChange={handleActivitiesInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-sm">
                              <div className="form-group">
                                <label
                                  htmlFor="description"
                                  className="font-weight-bold"
                                >
                                  Description
                                </label>
                                <textarea
                                  type="text"
                                  className="form-control"
                                  name="description"
                                  required
                                  value={inputsActivities.description || ""}
                                  onChange={handleActivitiesInputChange}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm">
                              <div className="form-group">
                                <label
                                  htmlFor="categoryId"
                                  className="font-weight-bold"
                                >
                                  Planned Start Date
                                </label>
                                <input
                                  type="date"
                                  className="form-control"
                                  name="plannedStartDate"
                                  required
                                  value={
                                    inputsActivities.plannedStartDate || ""
                                  }
                                  onChange={handleActivitiesInputChange}
                                />
                              </div>
                            </div>

                            <div className="col-sm">
                              <div className="form-group">
                                <label
                                  htmlFor="timeOfIncident"
                                  className="font-weight-bold"
                                >
                                  Timeline
                                </label>
                                <input
                                  type="date"
                                  className="form-control"
                                  name="plannedEndDate"
                                  required
                                  value={inputsActivities.plannedEndDate || ""}
                                  onChange={handleActivitiesInputChange}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm">
                              <div className="form-group">
                                <label
                                  htmlFor="categoryId"
                                  className="font-weight-bold"
                                >
                                  Actual Start Date
                                </label>
                                <input
                                  type="date"
                                  className="form-control"
                                  name="actualStartDate"
                                  required
                                  value={inputsActivities.actualStartDate || ""}
                                  onChange={handleActivitiesInputChange}
                                />
                              </div>
                            </div>

                            <div className="col-sm">
                              <div className="form-group">
                                <label
                                  htmlFor="timeOfIncident"
                                  className="font-weight-bold"
                                >
                                  Actual End Date
                                </label>
                                <input
                                  type="date"
                                  className="form-control"
                                  name="actualEndDate"
                                  required
                                  value={inputsActivities.actualEndDate || ""}
                                  onChange={handleActivitiesInputChange}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm">
                              <div className="form-group">
                                <label
                                  htmlFor="plannedBudget"
                                  className="font-weight-bold"
                                >
                                  Planned Budget
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  name="plannedBudget"
                                  required
                                  value={inputsActivities.plannedBudget || ""}
                                  onChange={handleActivitiesInputChange}
                                />
                              </div>
                            </div>

                            <div className="col-sm">
                              <div className="form-group">
                                <label
                                  htmlFor="timeOfIncident"
                                  className="font-weight-bold"
                                >
                                  Actual Budget
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  name="actualBudget"
                                  required
                                  value={inputsActivities.actualBudget || ""}
                                  onChange={handleActivitiesInputChange}
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <div className="d-flex flex-row">
                              {update ? (
                                <button
                                  className="btn btn-primary p-2"
                                  type="submit"
                                >
                                  Update
                                </button>
                              ) : (
                                <button
                                  className="btn btn-primary p-2"
                                  type="submit"
                                >
                                  Submit
                                </button>
                              )}
                              &nbsp;
                              <button
                                className="btn btn-warning p-2"
                                type="button"
                                onClick={handleCloseModal}
                              >
                                Close
                              </button>
                            </div>
                            <br />
                          </div>
                        </form>
                      )}
                    </div>
                    <div
                      className={`tab-pane fade ${
                        activeTab === "documents" ? "show active" : ""
                      }`}
                      id="documents-tab-pane"
                      role="tabpanel"
                      aria-labelledby="documents-tab"
                    >
                      {viewDocuments ? (
                        <div>
                          <button
                            className="btn-primary"
                            onClick={() => {
                              setViewDocuments(false);
                            }}
                          >
                            Add Document
                          </button>
                          <br />
                          <table className="table table-sm">
                            <tr>
                              <th>id</th>
                              <th>Type</th>
                              <th>Name</th>
                              <th>Description </th>
                              <th>View </th>
                            </tr>
                            <tbody>
                              {allDocuments.map((d) => (
                                <tr key={d.id}>
                                  <td>{d.id}</td>
                                  <td>{d.docType.name}</td>
                                  <td>{d.name}</td>
                                  <td>{d.description}</td>
                                  <td>
                                    <a
                                      href={
                                        process.env.REACT_APP_BASE_URL +
                                        "api/upload/files/" +
                                        d.path
                                      }
                                      target="_blank"
                                    >
                                      {" "}
                                      View{" "}
                                    </a>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          <br />
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <ActionsBtn />
                          </div>
                          <br />
                        </div>
                      ) : (
                        <form
                          className="form-horizontal"
                          onSubmit={HandleSubmitDocuments}
                        >
                          <button
                            className="btn-warning"
                            onClick={() => {
                              setViewDocuments(true);
                            }}
                          >
                            Back
                          </button>
                          <div className="row">
                            <div className="col-sm-6">
                              <div className="form-group">
                                <label
                                  htmlFor="name"
                                  className="font-weight-bold"
                                >
                                  Document Name
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="name"
                                  required
                                  value={documents.name || ""}
                                  onChange={handleDocumentsInputChange}
                                />
                              </div>
                            </div>
                            <div className="col-sm-6">
                              <div className="form-group">
                                <label
                                  htmlFor="name"
                                  className="font-weight-bold"
                                >
                                  Document Type
                                </label>
                                <Select
                                  name="typeId"
                                  value={documentTypes.filter(
                                    (option) =>
                                      option.value === documents.typeId,
                                  )}
                                  onChange={handleSelectDocumentsChange}
                                  options={documentTypes}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-sm">
                              <div className="form-group">
                                <label
                                  htmlFor="description"
                                  className="font-weight-bold"
                                >
                                  Description
                                </label>
                                <textarea
                                  type="text"
                                  className="form-control"
                                  name="description"
                                  required
                                  value={documents.description || ""}
                                  onChange={handleDocumentsInputChange}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12">
                              <input
                                type="file"
                                className="form-control"
                                name="file"
                                onChange={onChangeHandler}
                                accept=".xlsx, .xls, .csv"
                              />
                            </div>
                            <br />
                            <div className="col-sm-12">
                              <Progress
                                max="100"
                                color="success"
                                value={loaded}
                              >
                                {Math.round(loaded, 2)}%
                              </Progress>
                              <button
                                type="button"
                                class="btn btn-success "
                                onClick={onClickHandler}
                              >
                                Upload
                              </button>
                            </div>
                            <p>{message}</p>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <div className="d-flex flex-row">
                              {update ? (
                                <button
                                  className="btn btn-primary p-2"
                                  type="submit"
                                >
                                  Update
                                </button>
                              ) : (
                                <button
                                  className="btn btn-primary p-2"
                                  type="submit"
                                >
                                  Submit
                                </button>
                              )}
                              &nbsp;
                              <button
                                className="btn btn-warning p-2"
                                type="button"
                                onClick={handleCloseModal}
                              >
                                Close
                              </button>
                            </div>
                            <br />
                          </div>
                        </form>
                      )}
                    </div>
                  </div>

                  <br />
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    {/* <ActionsBtn /> */}
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AddMous;
